import {
  TextAppearance,
  TextLineHeight,
  TextSize,
  TextTag,
} from '@vw-marketing/us-components';

export const headingStyles: Record<
  1 | 2 | 3 | 4 | 5 | 6,
  {
    appearance: TextAppearance;
    tag: TextTag | 'h6';
    default: {
      fontSize: TextSize;
      lineHeight: TextLineHeight;
    };
    desktop: {
      fontSize: TextSize;
      lineHeight: TextLineHeight;
    };
    margin: string;
  }
> = {
  1: {
    appearance: TextAppearance.headline100,
    tag: TextTag.h1,
    default: {
      fontSize: TextSize.TextSize32,
      lineHeight: TextLineHeight.TextLineHeight40,
    },
    desktop: {
      fontSize: TextSize.TextSize36,
      lineHeight: TextLineHeight.TextLineHeight48,
    },
    margin: '1.5rem 0 1rem',
  },
  2: {
    appearance: TextAppearance.headline200,
    tag: TextTag.h2,
    default: {
      fontSize: TextSize.TextSize24,
      lineHeight: TextLineHeight.TextLineHeight32,
    },
    desktop: {
      fontSize: TextSize.TextSize28,
      lineHeight: TextLineHeight.TextLineHeight36,
    },
    margin: '1.5rem 0 0.75rem',
  },
  3: {
    appearance: TextAppearance.headline300,
    tag: TextTag.h3,
    default: {
      fontSize: TextSize.TextSize20,
      lineHeight: TextLineHeight.TextLineHeight28,
    },
    desktop: {
      fontSize: TextSize.TextSize24,
      lineHeight: TextLineHeight.TextLineHeight32,
    },
    margin: '1.5rem 0 0.5rem',
  },
  4: {
    appearance: TextAppearance.copy100,
    tag: TextTag.h4,
    default: {
      fontSize: TextSize.TextSize18,
      lineHeight: TextLineHeight.TextLineHeight24,
    },
    desktop: {
      fontSize: TextSize.TextSize20,
      lineHeight: TextLineHeight.TextLineHeight28,
    },
    margin: '1.25rem 0 0.5rem',
  },
  5: {
    appearance: TextAppearance.copy200,
    tag: TextTag.h5,
    default: {
      fontSize: TextSize.TextSize16,
      lineHeight: TextLineHeight.TextLineHeight24,
    },
    desktop: {
      fontSize: TextSize.TextSize18,
      lineHeight: TextLineHeight.TextLineHeight28,
    },
    margin: '0.875rem 0 0.5rem',
  },
  6: {
    appearance: TextAppearance.copy200,
    tag: 'h6' as any,
    default: {
      fontSize: TextSize.TextSize14,
      lineHeight: TextLineHeight.TextLineHeight20,
    },
    desktop: {
      fontSize: TextSize.TextSize16,
      lineHeight: TextLineHeight.TextLineHeight24,
    },
    margin: '0.75rem 0 0.5rem',
  },
};
